import React, { PureComponent } from 'react';
import Translate from 'client/components/translate';
import 'client/styles/error.scss';

class ServerErrorPage extends PureComponent {
  render() {
    return (
      <div className="error-page center-col" style={{ paddingTop: '2rem' }}>
        <div className="text-center pad-x">
          <h3><Translate path="common.error.oopsie" /></h3>
          <h3><Translate path="common.error.serverError" /></h3>

          <div className="error-image">
            <img alt="spilt_coffee" src="https://images.contentful.com/heg7gyzix6dq/40y2o3AzhuQ2WEe62GOWUs/4719e729ea64cfcb599f0f359663b00e/spilt_coffee.svg" />
          </div>

          <div style={{ fontWeight: 300 }}>
            <Translate path="common.error.requestAgain" />
          </div>

          <div style={{ paddingTop: '3rem' }}>
            <a href="/" style={{ fontWeight: 700 }}><Translate path="common.error.goHome" /></a>
          </div>
        </div>
      </div>
    );
  }
}

export default ServerErrorPage;
